<template>
    <div class="">
        <div class="text-22 text-blue-1 text-center">{{campaign.name}}</div>
        <div v-if="campaign.type != 32 && campaign.type != 33" class="text-22 text-green-1 text-center font-bold pb-2 border-b border-gray-2">{{getPointTxt()}}</div>
        <div v-if="campaign.type == 33" class="text-22 text-green-1 text-center font-bold pb-2 border-b border-gray-2">
            {{ getPrivilageTxt() }}
        </div>
        <div class="text-sm text-gray-400 flex pt-2">
            <img class="h-4 my-auto ml-auto mr-1" src="@/assets/icon/ic-expire.svg" alt="" />
            <div v-if="campaign.type == 33 && campaign.dayRemain > 0" class="ml-1">{{FilterStringFormat(lbl.detail.day_Remain, FilterNumberFormat(campaign.dayRemain))}}</div>
            <div class="my-auto mr-auto ml-1 text-18">{{FilterStringFormat(lbl.detail.expire_date, FilterDateFormat(campaign.expireDate))}}</div>
        </div>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "DetailInfo",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    methods: {
        getPointTxt: function () {
            let pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            let pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.FilterNumberFormat(this.campaign.pointPerUnit)} ${pointUnit}`;
        },
        agencyLogoUrl: function() {
            return ConfigManager.getBlobUrl() + "/agencies/" + this.campaign.agencyID;
        },
        getPrivilageTxt: function () {
            let pointTypeTxt = this.lbl.detail.use;

            let pointUnit = this.localeCode === 1033 && this.campaign.partialPoints.MaximumPartialPoints > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt} ${'฿'}${this.FilterNumberFormat(this.campaign.partialPoints.MaximumPartialPrice)} ${'+'} ${this.FilterNumberFormat(this.campaign.partialPoints.MaximumPartialPoints)} ${pointUnit}`;
        }
    },
}
</script>
